import {
  Grid,
  Typography,
  Button,
  Modal,
  IconButton,
  Fade,
  CircularProgress,
  useTheme,
  styled,
} from '@mui/material';

import { useState, useEffect } from 'react';

import LinkIcon from '@mui/icons-material/Link';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import LinearScaleIcon from '@mui/icons-material/LinearScale';

import {
  sendFlightsItinerary,
  saveSearchLink,
} from '@shared/services/services';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import SendedItineraryModal from './SendedItineraryModal.js';

import { useSelector, useDispatch } from 'react-redux';

import { setSearchLink } from '@shared/redux/actions';

import StyledTextField from '@shared/components/StyledTextField';

import { sxStyled } from './styles';

const BlackTypography = styled(Typography)({
  color: 'black',
  fontSize: '20px',
});

const SeeShareItineraryModal = ({
  seeShareItineraryModal,
  setSeeShareItineraryModal,
  legs,
  compositionPrice,
  infoFlightsSearch,
}) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const dispatch = useDispatch();
  const setCloseSeeShareItineraryModal = () => {
    setSeeShareItineraryModal(false);
  };

  const [sendedItineraryModal, setSendedItineraryModal] = useState(false);

  const getModalStyle = () => {
    return {
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
      margin: '0px',
      maxWidth: '800px',
      maxHeight: '400px',
    };
  };

  const [modalStyle] = useState(getModalStyle);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required('Campo requerido')
        .email('Ingrese un email valido'),
    }),
    onSubmit: values => {
      const { email } = values;
      legs?.sort((flightX, flightY) => flightX?.section - flightY?.section);
      const body = {
        email,
        legs,
        composition_price: compositionPrice,
      };
      sendFlightsItinerary(body)
        .then(() => {
          setSendedItineraryModal(true);
        })
        .catch(err => console.error('error:', err));
    },
    onChange: event => console.log('change', event.target.value),
  });

  const flightsSearch = useSelector(store => store.flightsSearch);
  const search_type = flightsSearch?.currentTripType;

  const searchLink = useSelector(store => store.searchLink);
  const flightsSearchBody = useSelector(store => store.flightsSearchBody);

  const [link, setLink] = useState(null);

  const getLink = body => {
    body.current_search = search_type;
    body.info_front_flights_search_body = infoFlightsSearch;
    const windowHref = window.location.href;
    const baseLink = `${windowHref}?share=`;
    if (!windowHref.includes('?share=')) {
      saveSearchLink(body)
        .then(res => {
          const newLink = `${baseLink}${res?.id}`;
          setLink(newLink);
          dispatch(
            setSearchLink({
              link: newLink,
            })
          );
        })
        .catch(() => setLink(`${baseLink}`));
    } else {
      setLink(windowHref);
      dispatch(
        setSearchLink({
          link: windowHref,
        })
      );
    }
  };

  useEffect(() => {
    if (!searchLink?.link) {
      getLink({ ...flightsSearchBody });
    } else {
      setLink(searchLink?.link);
    }
  }, []);

  const copyLink = () => {
    navigator.clipboard.writeText(link);
  };

  if (!sendedItineraryModal) {
    return (
      <Modal
        open={seeShareItineraryModal}
        onClose={setCloseSeeShareItineraryModal}
      >
        <Grid
          container
          direction="column"
          spacing={4}
          style={modalStyle}
          sx={sxStyle.itinerarySeeModalGrid}
        >
          <Grid item xs={12} style={{ paddingLeft: '0px' }}>
            <Grid
              style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
            >
              <LinkIcon fontSize="large" style={{ paddingRight: '4px' }} />
              <BlackTypography style={{ fontWeight: 600 }}>
                Compartir el enlace
              </BlackTypography>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            sx={sxStyle.linkItineraryModalContainer}
          >
            <Grid item xs={9} sx={sxStyle.linkItineraryModal}>
              {!link ? (
                <Fade
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    color: '#636466',
                    width: '100%',
                  }}
                  in={!link}
                  unmountOnExit
                >
                  <CircularProgress />
                </Fade>
              ) : (
                <BlackTypography sx={sxStyle.linkItineraryText}>
                  {link}
                </BlackTypography>
              )}
            </Grid>
            <Grid
              item
              xs={1}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <IconButton
                id="itinerary-copy-link"
                style={{ padding: '0px' }}
                onClick={() => copyLink()}
              >
                <FileCopyIcon
                  fontSize="large"
                  style={{
                    color: '#FFFFFF',
                    borderRadius: '50%',
                    backgroundColor: 'rgb(205 205 205)',
                    padding: '7px',
                  }}
                />
              </IconButton>
            </Grid>
            <Grid
              item
              xs={1}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <IconButton
                id="whatsapp-itinerary-link"
                style={{ padding: '0px' }}
                onClick={() => {
                  window.open(
                    'https://api.whatsapp.com/send?text=Enlace%20de%20busqueda:%20' +
                      link,
                    '_blank'
                  );
                }}
              >
                <WhatsAppIcon
                  fontSize="large"
                  style={{
                    color: '#FFFFFF',
                    borderRadius: '50%',
                    backgroundColor: '#03C868',
                    padding: '7px',
                  }}
                />
              </IconButton>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              paddingLeft: '0px',
              paddingTop: '40px',
              marginBottom: '0px',
            }}
          >
            <Grid
              style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
            >
              <LinearScaleIcon
                fontSize="large"
                style={{ paddingRight: '4px' }}
              />
              <BlackTypography style={{ fontWeight: 600 }}>
                Compartir el itinerario
              </BlackTypography>
            </Grid>
          </Grid>
          <form onSubmit={formik.handleSubmit} key="email">
            <Grid container item direction="row">
              <Grid item xs={9}>
                <StyledTextField
                  name="email"
                  label="Correo electrónico al que desee enviar"
                  formik={formik}
                />
              </Grid>

              <Grid
                item
                xs={3}
                style={{
                  display: 'flex',
                  justifyContent: 'end',
                }}
              >
                <Button
                  id="itinerary-close-modal"
                  sx={sxStyle.closeSeeShareItineraryModalBotton}
                  type="submit"
                  style={{
                    alignSelf: 'end',
                    color: theme.text1,
                    width: '150px',
                    marginBottom: '-3px',
                  }}
                >
                  Enviar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Modal>
    );
  } else {
    return (
      <SendedItineraryModal
        sendedItineraryModal={sendedItineraryModal}
        setSendedItineraryModal={setSendedItineraryModal}
        BlackTypography={BlackTypography}
        modalStyle={modalStyle}
        setCloseSeeShareItineraryModal={setCloseSeeShareItineraryModal}
      />
    );
  }
};

export default SeeShareItineraryModal;
